import { BubbleState } from '../../../../../../components/bubble/types/state';
import { BubbleVariantType } from '../../../../../../components/bubble/types/variants';
import { ButtonSizeType, ButtonVariantType } from '../../button/variants';
import { ThirdPartyAnimationSizesType, ThirdPartyAnimationVariantType, } from '../../thirdPartyAnimation/variants';
import { inboundMessageCommonStyles } from '../commonStyles';
export const getInboundMessageChatbotWithButtonStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [BubbleVariantType.INBOUND_MESSAGE_CHATBOT_WITH_BUTTON]: {
            [BubbleState.DEFAULT]: {
                ...inboundMessageCommonStyles(FOUNDATIONS, FONT, SHADOWS),
                messageContainer: {
                    ...inboundMessageCommonStyles(FOUNDATIONS, FONT, SHADOWS).messageContainer,
                    padding: `${FOUNDATIONS.spacing_125} ${FOUNDATIONS.spacing_250}`,
                    min_width: FOUNDATIONS.size_675,
                },
                button: {
                    variant: ButtonVariantType.PRIMARY_GHOST,
                    size: ButtonSizeType.EXTRA_SMALL,
                    loader: {
                        variant: ThirdPartyAnimationVariantType.SECONDARY,
                        size: ThirdPartyAnimationSizesType.SMALL,
                    },
                },
            },
            [BubbleState.PENDING]: {
                ...inboundMessageCommonStyles(FOUNDATIONS, FONT, SHADOWS),
                messageContainer: {
                    ...inboundMessageCommonStyles(FOUNDATIONS, FONT, SHADOWS).messageContainer,
                    padding: `${FOUNDATIONS.spacing_125} ${FOUNDATIONS.spacing_250}`,
                    min_width: FOUNDATIONS.size_675,
                },
                button: {
                    variant: ButtonVariantType.PRIMARY_GHOST,
                    size: ButtonSizeType.EXTRA_SMALL,
                    loader: {
                        variant: ThirdPartyAnimationVariantType.SECONDARY,
                        size: ThirdPartyAnimationSizesType.SMALL,
                    },
                },
            },
            [BubbleState.ERROR]: {
                ...inboundMessageCommonStyles(FOUNDATIONS, FONT, SHADOWS),
                messageContainer: {
                    ...inboundMessageCommonStyles(FOUNDATIONS, FONT, SHADOWS).messageContainer,
                    padding: `${FOUNDATIONS.spacing_125} ${FOUNDATIONS.spacing_250}`,
                    min_width: FOUNDATIONS.size_675,
                },
                errorTextContainer: {
                    display: 'flex',
                    justify_content: 'end',
                },
                button: {
                    variant: ButtonVariantType.PRIMARY_GHOST,
                    size: ButtonSizeType.EXTRA_SMALL,
                    loader: {
                        variant: ThirdPartyAnimationVariantType.SECONDARY,
                        size: ThirdPartyAnimationSizesType.SMALL,
                    },
                },
            },
            [BubbleState.LOADING_TYPING]: {
                ...inboundMessageCommonStyles(FOUNDATIONS, FONT, SHADOWS),
                messageContainer: {
                    ...inboundMessageCommonStyles(FOUNDATIONS, FONT, SHADOWS).messageContainer,
                    min_width: FOUNDATIONS.size_675,
                    padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_150}`,
                },
                loader: {
                    variant: ThirdPartyAnimationVariantType.BUBBLE,
                    size: ThirdPartyAnimationSizesType.SMALL,
                },
                button: {
                    variant: ButtonVariantType.PRIMARY_GHOST,
                    size: ButtonSizeType.EXTRA_SMALL,
                    loader: {
                        variant: ThirdPartyAnimationVariantType.SECONDARY,
                        size: ThirdPartyAnimationSizesType.SMALL,
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=inboundMessageChatbotWithButton.js.map